 <template>
  <div class="cEpage _boxBg_dark_big absolute_center">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">
      低碳发展指标评价体系（C+4E）
      <span  class="my-btn" @click="tipHandle">i</span>
      <div v-show="isTip" class="info">
        <div class="WB_arrow">
          <em class="S_line1_c">◆</em>
          <span class="S_bg1_c">◆</span>
          <div class="s-info">建立以碳生产率（Carbon Productivity）为核心的C+4E低碳发展评价体系，核心思想为:以提高碳生产率（Carbon Productivity）为核心，实现节约能源（Energy Saving），提高经济效益（Economic Efficiency )，环境协同治理（Environment SynergyEco-industrial chain）。</div>
        </div>
      </div>
    </div>
    
    <div class="yellowLine"></div>
    <div class="_innerBox">
      <div class="leftBox">
        <div class="leftBox-main">
          碳生产率 <span class="dinBold">{{carbonData}}</span>元/tCO₂
        </div>
        <div class="leftBox-box">
          <ul>
            <li v-for="(item , i) in dataList" :key="item.key" :style="{display:i==4?'none':'block'}">
              <template v-if="i == 1">
                <ul>
                  <div class="li_title">{{item.title}}</div>
                  <li class="li_two_column" v-for="(item_,i_) in item.list" :key="i_" @click="openOtherPage(item.title ,item_.name)">
                    <div class="li_left">{{item_.name}}</div>
                    <div class="li_right">
                      <span>{{toFixed(item_.statistic)}}{{item_.staticUnit}}</span><span>{{toFixed(item_.value)}}{{item_.unit}}</span>
                    </div>
                  </li>
                </ul>
              </template>
              <template v-else-if="i != 4">
                <ul>
                  <div class="li_title">{{item.title}}</div>
                  <li v-for="(item_,i_) in item.list" :key="i_" @click="openOtherPage(item.title ,item_.name)">
                    <div class="li_left">{{item_.name}}</div>
                    <div class="li_right">{{item_.value}}{{item_.unit}}</div>
                  </li>
                  <template v-if="i ==3">
                    <div class="li_title">{{dataList[i+1].title}}</div>
                    <li v-for="(item2_,i2_) in dataList[i+1].list" :key="i2_" @click="openOtherPage(item.title ,item_.name)">
                      <div class="li_left">{{item2_.name}}</div>
                      <div class="li_right">{{item2_.value}}{{item2_.unit}}</div>
                    </li>
                  </template>
                </ul>
              </template>
            </li>
          </ul>
        </div>
      </div>
      <div class="rightBox"></div>
    </div>
  </div>
</template>

<script>
import { unwarp } from "@/utils/tools.js";
import { mapGetters } from "vuex";
import detailPage from "@/modules/DIYcomponents/components/2_2/LC_quota/components/quotaDetailPage.vue";
import powerPage from "@/modules/lowcarbonComponents/lowCarbonPopup2/indexNew.vue";
import ProcessPage from "@/modules/lowcarbonComponents/carbonDischargeInfo/carbonEmissionProcess.vue";
export default {
  props: {},
  data() {
    return {
      isTip: false,
      dataList: [
        {
          key: "control",
          title: "总量及强度控制",
          list: [
            { name: "能源消费总量", value: "0" },
            { name: "碳排放总量", value: "0" },
            { name: "煤炭消耗总量", value: "0" },
            { name: "焦炭消耗总量", value: "0" },
            { name: "吨钢综合能耗", value: "0" },
            { name: "吨钢二氧化碳排放强度", value: "0" },
          ],
        },
        {
          key: "process",
          title: "工序能耗及排放",
          list: [
            { name: "原料厂工序", value: "0" },
            { name: "烧结工序", value: "0" },
            { name: "炼铁工序", value: "0" },
            { name: "炼钢工序", value: "0" },
            { name: "轧钢工序", value: "0" },
            { name: "其他工序", value: "0" },
          ],
        },
        {
          key: "cooperative",
          title: "协同污染物治理",
          list: [
            { name: "吨钢颗粒物排放量", value: "0" },
            { name: "吨钢SO2排放量", value: "0" },
            { name: "吨钢NOx排放量", value: "0" },
            { name: "吨钢环保运行成本", value: "0" },
          ],
        },
        {
          key: "energy",
          title: "能源资源利用效率",
          list: [
            { name: "余热余能自发电率", value: "0" },
            { name: "余热为周边区域供热面积", value: "0" },
            { name: "固废资源化利用率", value: "0" },
          ],
        },
        {
          key: "reduce",
          title: "成本改善",
          list: [{ name: "吨钢能源成本", value: "0" }],
        },
      ],
      carbonData: "",
      customerId: this.$store.state.customerId,
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
      dialogCompontent3: "getDialogCompontent3",
    }),
    toFixed() {
      return (i) => {
        if (!i) return 0;
        return Number(i).toFixed(2);
      };
    },
  },
  mounted() {
    if (bmeConfig.isNewCarbon) { // 新版低碳结构
      this.getCarbon()
      this.newGetListData()
    } else { // 老板低碳结构
      this.getListData();
    }
  },
  methods: {
    async getListData() {
      let getCarbonEfficiency =
        CONFIG.requestName + this.$apiOpt.getCarbonEfficiency;
      let res = await this.$apiUtils.get(getCarbonEfficiency, {
        customerId: this.customerId,
      });
      if (res) {
        this.carbonData = res.carbon;
        res.dataList &&
          this.dataList.forEach((item, i) => {
            res.dataList.forEach((item_, i_) => {
              if (item.key == item_.key) {
                item.title = item_.title;
                item.list = item_.list;
              }
            });
          });
      }
    },
    // 新版低碳获取信息接口 之前的getCarbonEfficiency接口，变为两个接口
    async getCarbon() {
      let carbonProductivity =
        CONFIG.requestName + this.$apiOpt.carbonProductivity;
      let res = await this.$apiUtils.get(carbonProductivity, {
        customerId: this.customerId,
      });
      this.carbonData = res ? res : 0;
    },
    newGetListData() {
      let getCarbonEfficiency =
        CONFIG.requestName + this.$apiOpt.getCarbonEfficiency;
      
      this.dataList.forEach(item => {
        this.$apiUtils.get(getCarbonEfficiency, {
          customerId: this.customerId,
          key: item.key,
        }).then((res) => {
          if (res) {
            item.title = res.title;
            item.list = res.list;
          }
        })
      })
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
      $(".dialogComponent3").removeClass("left50");
      $(".dialogComponent3 .removeDust_historicalTrend").removeClass("center");
      $(".dialogComponent2").removeClass("left0");
      $(".dialogComponent2 .removeDust_historicalTrend").removeClass("center");
    },
    openOtherPage(title, name) {
      console.log("title , name", title, name);
      if (name == "碳排放总量") {
        this.$store.commit("dialogStatus2", true);
        this.$popup.open2(detailPage, this.dialogCompontent2, null, {
          fromPage: "close2",
        });
      } else if (name == "能源消费总量") {
        this.$store.commit("dialogStatus2", true);
        this.$popup.open2(powerPage, this.dialogCompontent2, null, {
          fromPage: "close2",
          params: "power",
        });
      } else if (name == "煤炭消耗总量") {
        this.$store.commit("dialogStatus2", true);
        this.$popup.open2(powerPage, this.dialogCompontent2, null, {
          fromPage: "close2",
          params: "coal",
        });
      } else if (name == "焦炭消耗总量") {
        this.$store.commit("dialogStatus2", true);
        this.$popup.open2(powerPage, this.dialogCompontent2, null, {
          fromPage: "close2",
          params: "coke",
        });
      } else if (title == "工序能耗及排放") {
        this.$store.commit("dialogStatus3", true);
        this.$popup.open3(ProcessPage, this.dialogCompontent3, null, {
          fromPage: "close3",
          params: "ce4",
        });
        this.$nextTick(() => {
          $(".dialogComponent3").addClass("left50");
          $(".dialogComponent3 .removeDust_historicalTrend").addClass("center");
          $(".dialogComponent2").addClass("left0");
        });
      }
    },
    tipHandle() {
      this.isTip = !this.isTip;
      console.log(this.isTip)
    }
  },
};
</script>
<style>
.left50 {
  left: 50% !important;
}
.left0 {
  left: 0 !important;
  z-index: 4 !important;
}
.center {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
</style>
<style lang="scss" scoped>
._boxBg_dark_big {
  width: 2830px !important;
  height: auto;
}
.cEpage {
  // width: 75%;
  .yellowLine {
    width: 350px;
    height: 3px;
    background: #ffad25;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    border-radius: 2px 2px 0px 0px;
    margin: 0 auto;
  }
  ._innerBox {
    padding: 0 50px;
    display: flex;
    justify-content: space-around;
    .leftBox {
      .leftBox-main {
        width: 626px;
        height: 100px;
        background: linear-gradient(
          270deg,
          rgba(108, 151, 255, 0) 0%,
          rgba(58, 116, 255, 0.1) 100%
        );
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
        border: 1px solid;
        margin-bottom: 20px;
        border-image: linear-gradient(to left, #ffffff00, #a9c8fb) 1 10;
        margin-top: 25px;
        font-size: 26px;
        color: #f5a623;
        line-height: 100px;
        padding: 0 30px;
        span {
          margin: 0 11px 0 83px;
          font-size: 48px;
          font-weight: bold;
          color: #4be0ff;
          line-height: 48px;
        }
      }
      .leftBox-box {
        width: 2090px;
        height: 569px;
        & > ul {
          width: 100%;
          height: 100%;
          display: flex;
          & > li {
            width: 510px;
            height: 100%;
            padding: 20px 30px;
            background: linear-gradient(
              360deg,
              rgba(108, 151, 255, 0) 0%,
              rgba(58, 116, 255, 0.1) 100%
            );
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
            border: 1px solid;
            border-image: linear-gradient(to top, #ffffff00, #a9c8fb) 1 10;
            margin-right: 20px;
            overflow: auto;
            &::-webkit-scrollbar {
              width: 0px;
              height: 4px;
              width: 0;
            }
            & > ul {
              height: 492px;
              width: 100%;
              .li_title {
                font-size: 26px;
                line-height: 37px;
                margin-bottom: 20px;
              }
              & > li {
                cursor: pointer;
                width: 100%;
                height: 50px;
                margin-bottom: 20px;
                padding: 10px;
                background: linear-gradient(
                  270deg,
                  rgba(49, 52, 75, 0) 0%,
                  #161824 100%
                );
                display: flex;
                justify-content: space-between;
                align-items: center;
                .li_left {
                  font-size: 18px;
                  color: #c8d8ff;
                }
                .li_right {
                  font-size: 18px;
                  color: #4be0ff;
                }
              }
              & > li.li_two_column {
                .li_right {
                  width: 80%;
                  display: flex;
                  justify-content: space-between;
                }
              }
            }
          }
        }
      }
    }
    .rightBox {
      @include bg-box(468px, 571px, "carbonPro.png");
      margin: 100px 0px 0px 70px;
    }
  }
}
.my-btn {
  position: absolute;
  top: 15px;
  left: 58%;
  display: inline-block;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  line-height: 30px;
  background: linear-gradient(180deg, #94E1FF 0%, #5BC0FF 100%);
  box-shadow: 0px 3px 5px 0px rgba(63, 231, 250, 0.33);
  border: 1px solid #99F5FF;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}
.info {
  width: 500px;
  height: 136px;
  position: absolute;
  top: 80px;
  left: 58%;
  background-color: #1E1000;
  box-shadow: 10px 20px 40px 0px rgba(177, 114, 11, 0.27);
  border: 2px solid #F4C48F;
  .S_line1_c,
  .S_bg1_c {
    position: absolute;
    left: -7px;
    font-size: 70px;
  }
  .S_line1_c {
    top: -30px;
    color: #1E1000;
    z-index: 1000;
  }
  .S_bg1_c {
    top: -34px;
    color: #F4C48F;
  }
  .s-info {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1001;
    line-height: 34px;
    font-size: 14px;
  }
}
</style>